/* has-no-next:
 *
 * This plugin example sets body.hasNoNext when the current node name
 * matches a predefined regular expression, and unsets it when does not.
 *
 * Author: Niels Giesen
 * Copyright (C) 2017 by Berkeley Bridge
 */

(function ($) {
  // Regular expressions to test absolute node names against:
  var endNodes = [/\.overzicht$/];

  function test(group) {
    return (
      group.current &&
      endNodes.some(function (re) {
        return re.test(group.name);
      })
    );
  }

  $(document).on("bb:preHandleData", function (event, data) {
    if (data && data.groups && data.groups[0]) {
      if (data.hasnext === false) return;
      if (data.groups.some(test)) data.hasnext = false;
    }
  });
})(jQuery);
